import React, { useState } from "react";
import { Match } from "../../models/Match";
import styles from "./modal.module.css"; // Reuse the same modal styles
import { updateMatch } from "../../services/MatchService";

interface MatchProps {
    match: Match;
    onClose: () => void;
}

export const EditMatchModal: React.FC<MatchProps> = ({ match, onClose }) => {
    const [team1Score, setTeam1Score] = useState<number>(match.team1score);
    const [team2Score, setTeam2Score] = useState<number>(match.team2score);
    const [roundNumber, setRoundNumber] = useState<number | null>(match.roundNumber);
    const [status, setStatus] = useState<string | null>(null);

    const handleSave = () => {
        const updatedMatch = { ...match, team1score: team1Score, team2score: team2Score };
        onSave(updatedMatch);
        onClose();
    };

    async function onSave(match: Match) {
        try {
            await updateMatch(match);
            setStatus("Kamp gemt")
        }
        catch (error) {
            setStatus("Fejl ved gemning af kamp")
        }
    }

    return (
        <div className={styles.modal}>
            <div className={styles["modal-content"]}>
                <h2>Edit Scores</h2>
                <div>
                    <label>{match.team1.teamName} Score:</label>
                    <input
                        type="number"
                        value={team1Score}
                        onChange={(e) => setTeam1Score(Number(e.target.value))}
                        className={styles.input}
                    />
                </div>
                <div>
                    <label>{match.team2.teamName} Score:</label>
                    <input
                        type="number"
                        value={team2Score}
                        onChange={(e) => setTeam2Score(Number(e.target.value))}
                        className={styles.input}
                    />
                </div>
                <div>
                    <label>Angiv en runde for playoff:</label>
                    <input
                        type="number"
                        value={roundNumber ?? ""}
                        onChange={(e) => setRoundNumber(Number(e.target.value))}
                        className={styles.input}
                    />
                </div>
                {
                    status && <div>{status}</div>
                }
                <div className={styles["modal-actions"]}>
                    <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
                    <button className="btn btn-primary" onClick={handleSave}>Save</button>
                </div>
            </div>
        </div>
    );
};

